<script>
import { required, requiredIf, email } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

// Custom Compnents
import GuestService from "@/helpers/APIService/guest.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import {
  gender_type,
  documnet_type,
  documnet_status,
} from "@/helpers/global.variable";

export default {
  components: {
    VueDropify,
    VueCropper,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  data() {
    return {
      guest: {
        doc_image_status: "P",
        selfie_image_status: "P",
        mobile_iso: "US",
      },
      selfie_image_imgURL: "",
      doc_image_imgURL: "",
      mobile_code: "+1 ",
      guestId: "",
      isEdit: false,
      isBtnLoading: false,
      submitted: false,
      rejectionSubmitted: false,
      gender_type,
      document_type: documnet_type,
      document_status: documnet_status,
      personalInfo: true,
      documentInfo: false,
      geolocationInfo: false,
      isError: false,
      isDocEdit: false,
      isSelfieEdit: false,
      docImageVerification: false,
      selfieImageVerification: false,
      isSaveAndAddNew: false,
      createError: false,
      errorMessage: null,
    };
  },
  validations: {
    guest: {
      email: {
        required,
        email,
      },
      doc_image_status_change_reason: {
        required: requiredIf(function () {
          if (this.guest.doc_image_status === "R") {
            return true;
          }
        }),
      },
      selfie_image_status_change_reason: {
        required: requiredIf(function () {
          if (this.guest.selfie_image_status === "R") {
            return true;
          }
        }),
      },
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.editGuest();
  },
  methods: {
    // Method is used for add and update guest detail
    handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.guest.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.guest.mobile !== "" || null) {
          this.guest.mobile = this.removeNumberDecorations(
            this.mobile_code + this.guest.mobile
          );
        } else {
          this.guest.mobile_iso = "US";
          this.guest.mobile = "";
        }
        if (this.selfie_image_imgURL !== "") {
          this.guest.selfie_image = this.createImageFromBase(
            this.$refs.cropper.getCroppedCanvas().toDataURL(),
            "selfie_image.jpg"
          );
        }
        if (this.doc_image_imgURL !== "") {
          this.guest.doc_image = this.createImageFromBase(
            this.$refs.cropper.getCroppedCanvas().toDataURL(),
            "doc_image.jpg"
          );
        }
        const guestData = new FormData();
        if (this.guest.selfie_image_status !== "R") {
          delete this.guest.selfie_image_status_change_reason;
        }
        if (this.guest.doc_image_status !== "R") {
          delete this.guest.doc_image_status_change_reason;
        }
        delete this.guest.fingerprint_js_data;
        Object.keys(this.guest).map((key) => {
          if (this.guest[key] !== null || undefined || "") {
            guestData.append(key, this.guest[key]);
          }
          if (key === "doc_ocr_text") {
            guestData.delete(key);
          }
          if (key === "selfie_image") {
            if (typeof this.guest[key] === "string") {
              guestData.delete(key);
            }
          }
          if (key === "doc_image") {
            if (typeof this.guest[key] === "string") {
              guestData.delete(key);
            }
          }
        });
        guestData.append("id_text_ocr", 1);
        guestData.append("id_photo_verification_with_selfie", 1);
        if (!this.isEdit) {
          guestData.append("hotel", this.hotel.id);
        }
        if (!this.isEdit) {
          GuestService.createGuest(guestData)
            .then((response) => {
              if (!this.isSaveAndAddNew) {
                this.$emit("submitted", response);
              } else {
                this.$emit("saveAndAddNew", response);
                this.guest = {
                  doc_image_status: "P",
                  selfie_image_status: "P",
                  mobile_iso: "US",
                  selfie_image: "",
                  first_name: "",
                  last_name: "",
                  mobile: "",
                  email: "",
                  gender: "",
                  date_of_birth: "",
                  selfie_image_status_change_reason: "",
                  address_line_first: "",
                  address_line_second: "",
                  city: "",
                  state: "",
                  country: "",
                  zip_code: "",
                  doc_image: "",
                  doc_image_imgURL: "",
                  doc_type: "",
                  doc_number: "",
                  doc_issue_date: "",
                  doc_expire_date: "",
                  doc_issued_by: "",
                  doc_image_status_change_reason: "",
                };
              }
              this.isBtnLoading = false;
              this.submitted = false;
              this.selfie_image_imgURL = "";
              this.doc_image_imgURL = "";
              Middleware.notification("Added successfully !!", "success", 2000);
            })
            .catch((error) => {
              errorHandler(error);
              this.isBtnLoading = false;
              this.createError = true;
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          GuestService.editGuest(guestData, this.guestId)
            .then((response) => {
              this.$emit("submitted", response, this.guestId, this.isEdit);
              this.guest.selfie_image = response.selfie_image;
              this.guest.doc_image = response.doc_image;
              this.selfie_image_imgURL = "";
              this.doc_image_imgURL = "";
              this.isBtnLoading = false;
              this.submitted = false;
              Middleware.notification(
                "Updated successfully !!",
                "success",
                2000
              );
            })
            .catch((error) => {
              errorHandler(error);
              this.isBtnLoading = false;
              this.createError = true;
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },
    // Method is used for handle edit guest information
    editGuest() {
      if (this.currentProps.isEdit) {
        GuestService.getGuestDetail(this.currentProps.guest.id)
          .then((response) => {
            delete response.fingerprint_js_data;
            response.mobile =
              response.mobile !== null
                ? response.mobile
                    .trim()
                    .substring(response.mobile.indexOf(" ") + 1)
                : "";
            this.guest = response;
          })
          .catch((error) => {
            errorHandler(error);
          });
        // this.guest = this.currentProps.guest;
        this.guestId = this.currentProps.guestId;
        this.isEdit = this.currentProps.isEdit;
      }
    },
    // Method is used for handle change of selfie image
    changeSelfieImage(event) {
      this.selfieImageVerification = true;
      if (event[0] !== undefined) {
        this.guest.selfie_image = event[0] == undefined ? null : event[0];
        this.selfie_image_imgURL = URL.createObjectURL(event[0]);
        this.guest.selfie_image_status = "U";
        if (this.currentProps.isEdit) {
          const guestData = new FormData();
          Object.keys(this.guest).map((key) => {
            if (key === "selfie_image") {
              guestData.append(key, this.guest[key]);
            }
          });
          guestData.append("id_text_ocr", 1);
          guestData.append("id_photo_verification_with_selfie", 1);
          GuestService.editGuest(guestData, this.guestId)
            .then((response) => {
              this.guest.selfie_image_status = response.selfie_image_status;
              this.guest.selfie_image = response.selfie_image;
              this.guest.selfie_image_status_change_reason !== null
                ? response.selfie_image_status_change_reason.replace("OCR", "")
                : this.guest.selfie_image_status_change_reason;
              this.selfieImageVerification = false;
            })
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          this.selfieImageVerification = false;
        }
      } else {
        this.guest.selfie_image_status = "U";
        const guestData = new FormData();
        Object.keys(this.guest).map((key) => {
          if (key === "selfie_image") {
            guestData.append(key, "");
          }
        });
        guestData.append("id_text_ocr", 1);
        guestData.append("id_photo_verification_with_selfie", 1);
        GuestService.editGuest(guestData, this.guestId)
          .then((response) => {
            this.guest.selfie_image_status = response.selfie_image_status;
            this.guest.selfie_image = response.selfie_image;
            this.guest.selfie_image_status_change_reason !== null
              ? response.selfie_image_status_change_reason.replace("OCR", "")
              : this.guest.selfie_image_status_change_reason;
            this.selfieImageVerification = false;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    // Method is used for handle change of dov image
    changeDocImage(event) {
      this.docImageVerification = true;
      if (event[0] !== undefined) {
        this.guest.doc_image = event[0] == undefined ? null : event[0];
        this.doc_image_imgURL = URL.createObjectURL(event[0]);
        this.guest.doc_image_status = "U";
        if (this.currentProps.isEdit) {
          const guestData = new FormData();
          Object.keys(this.guest).map((key) => {
            if (key === "doc_image") {
              guestData.append(key, this.guest[key]);
            }
          });
          guestData.append("id_text_ocr", 1);
          guestData.append("id_photo_verification_with_selfie", 1);
          GuestService.editGuest(guestData, this.guestId)
            .then((response) => {
              this.docImageVerification = false;
              this.guest.selfie_image_status = response.selfie_image_status;
              this.guest.doc_image_status = response.doc_image_status;
              this.guest.doc_image_status_change_reason =
                response.doc_image_status_change_reason.replace(
                  "OCR",
                  "Document"
                );
              this.guest.doc_type = response.doc_type;
              this.guest.doc_number = response.doc_number;
              this.guest.doc_issued_by = response.doc_issued_by;
              this.guest.first_name = response.doc_ocr_text.FIRST_NAME;
              this.guest.last_name = response.doc_ocr_text.LAST_NAME;
              this.guest.doc_image = response.doc_image;
              this.guest.doc_expire_date = response.doc_expire_date;
              this.guest.doc_issue_date = response.doc_issue_date;
              this.guest.date_of_birth = response.date_of_birth;
            })
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          this.docImageVerification = false;
        }
      } else {
        this.guest.doc_image_status = "U";
        const guestData = new FormData();
        Object.keys(this.guest).map((key) => {
          if (key === "doc_image") {
            guestData.append(key, "");
          }
        });
        guestData.append("id_text_ocr", 1);
        guestData.append("id_photo_verification_with_selfie", 1);
        GuestService.editGuest(guestData, this.guestId)
          .then((response) => {
            this.docImageVerification = false;
            this.guest.selfie_image_status = response.selfie_image_status;
            this.guest.doc_image_status = response.doc_image_status;
            this.guest.doc_image_status_change_reason =
              response.doc_image_status_change_reason.replace(
                "OCR",
                "Document"
              );
            this.guest.doc_type = response.doc_type;
            this.guest.doc_number = response.doc_number;
            this.guest.doc_issued_by = response.doc_issued_by;
            this.guest.first_name = response.doc_ocr_text.FIRST_NAME;
            this.guest.last_name = response.doc_ocr_text.LAST_NAME;
            this.guest.doc_image = response.doc_image;
            this.guest.doc_expire_date = response.doc_expire_date;
            this.guest.doc_issue_date = response.doc_issue_date;
            this.guest.date_of_birth = response.date_of_birth;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    // Method is used for handle change of selfie image status
    editSelfieStatus() {
      this.isSelfieEdit = true;
    },
    // Method is used for handle change of doc image status
    editDocStatus() {
      this.isDocEdit = true;
    },
    // Method is used for handle change of doc image status submission
    submitDocStatus() {
      const guestData = new FormData();
      guestData.append("doc_image_status", this.guest.doc_image_status);
      if (this.guest.doc_image_status === "R") {
        if (this.guest.doc_image_status_change_reason == "") {
          return Middleware.notification(
            "Please add document rejection reason !!",
            "danger"
          );
        } else {
          guestData.append(
            "doc_image_status_change_reason",
            this.guest.doc_image_status_change_reason
          );
        }
      } else {
        guestData.append("doc_image_status_change_reason", "");
      }
      guestData.append("id_text_ocr", 1);
      guestData.append("id_photo_verification_with_selfie", 1);
      GuestService.editGuest(guestData, this.guest.id)
        .then(() => {
          Middleware.notification(
            "Document verification status changed !!",
            "success",
            2000
          );
          this.isDocEdit = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for handle change of selfie image status submission
    submitSelfieStatus() {
      const guestData = new FormData();
      guestData.append("selfie_image_status", this.guest.selfie_image_status);
      if (this.guest.selfie_image_status === "R") {
        if (this.guest.selfie_image_status_change_reason == "") {
          return Middleware.notification(
            "Please add selfie image rejection reason !!",
            "danger"
          );
        } else {
          guestData.append(
            "selfie_image_status_change_reason",
            this.guest.selfie_image_status_change_reason
          );
        }
      } else {
        guestData.append("selfie_image_status_change_reason", "");
      }
      guestData.append("id_text_ocr", 1);
      guestData.append("id_photo_verification_with_selfie", 1);
      GuestService.editGuest(guestData, this.guest.id)
        .then((response) => {
          this.guest = response;
          Middleware.notification(
            "Selfie image verification status changed !!",
            "success",
            2000
          );
          this.isSelfieEdit = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for handle country change
    countryChange(code) {
      this.guest.mobile_iso = code.iso2;
      this.mobile_code = "+" + code.dialCode;
    },
    // Method is used for convert image to base64
    createImageFromBase(dataUrl, filename) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    // Method is used for handle add and add countinue add guest
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
    },
    // Method is used for cancel guest form
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    // Method is used for handle to remove number decoration
    removeNumberDecorations(mobile_number) {
      const mobile_number_copy = mobile_number.replace(" ", "");
      const number = mobile_number_copy.replace(/[^a-zA-Z0-9 ]/g, "");
      return number;
    },
  },
};
</script>

<template>
  <div>
    <div class="offcanvas-header py-0">
      <h4 class="offcanvas-title" id="offcanvasExampleLabel">
        {{ this.isEdit ? "Update" : "Add New" }} Guest Details
      </h4>
      <h4 v-if="createError">
        <template v-if="typeof errorMessage == 'object'">
          <span v-for="error in errorMessage" :key="error">
            <span class="badge card-badge badge-soft-danger">
              <b>{{ error }}</b>
            </span>
            <br />
          </span>
        </template>
        <template v-else>
          <span class="badge card-badge badge-soft-danger">
            <b>{{ errorMessage }}</b>
          </span>
        </template>
      </h4>
    </div>
    <hr />
    <div class="offcanvas-body">
      <form
        ref="guest-form"
        @submit.stop.prevent="handleSubmit"
        class="tablist"
      >
        <!-- Start Personal information section -->
        <b-card no-body>
          <b-card-header
            header-tag="header"
            role="tab"
            v-b-toggle.personalInfoValidation
          >
            <h6 class="my-1" slot="header">
              Personal Information
              <span
                v-if="submitted && $v.guest.$invalid"
                class="my-1 badge align-items-center card-badge badge-soft-danger float-end"
              >
                <b>Personal Information Have Error</b>
              </span>
            </h6>
          </b-card-header>
          <b-collapse
            id="personalInfoValidation"
            :visible="personalInfo"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <div class="col-md-4" v-if="!selfieImageVerification">
                    <VueDropify
                      v-if="selfie_image_imgURL == ''"
                      @upload="changeSelfieImage($event)"
                      :src="guest.selfie_image ? guest.selfie_image : ''"
                      message="Drop image here or click to select"
                    />
                    <vue-cropper
                      v-else
                      ref="cropper"
                      :src="selfie_image_imgURL"
                      alt="Source Image"
                      class="position-relative w-100 object-fit"
                      :minCropBoxWidth="150"
                      :minCropBoxHeight="150"
                    >
                    </vue-cropper>
                    <label for="" class="mt-4 form-label"
                      >Selfie Image Status
                      <i
                        class="far fa-eye ms-1"
                        v-b-popover.hover="'View OCR text'"
                        v-b-modal.view-doc-text
                      ></i>
                    </label>
                    <div
                      class="badge bg-primary d-flex justify-content-between align-items-center mb-2"
                      v-if="guest.selfie_image_status == 'P'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-clock"></i> Pending
                      </span>
                      <span class="fs-6"
                        ><i
                          class="fas fa-pencil-alt"
                          @click="editSelfieStatus"
                        ></i
                      ></span>
                    </div>
                    <div
                      class="badge bg-warning d-flex justify-content-between align-items-center mb-2"
                      v-if="guest.selfie_image_status == 'U'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-upload"></i> Uploaded
                      </span>
                      <span class="fs-6"
                        ><i
                          class="fas fa-pencil-alt"
                          @click="editSelfieStatus"
                        ></i
                      ></span>
                    </div>
                    <div
                      class="badge bg-danger d-flex justify-content-between align-items-center mb-2"
                      v-if="guest.selfie_image_status == 'R'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-ban"></i> Rejected
                      </span>
                      <span class="fs-6"
                        ><i
                          class="fas fa-pencil-alt"
                          @click="editSelfieStatus"
                        ></i
                      ></span>
                    </div>
                    <div
                      class="badge bg-success d-flex justify-content-between align-items-center mb-2"
                      v-if="guest.selfie_image_status == 'V'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-shield-alt"></i> Verified
                      </span>
                      <span class="fs-6"
                        ><i
                          class="fas fa-pencil-alt"
                          @click="editSelfieStatus"
                        ></i
                      ></span>
                    </div>

                    <b-form
                      inline
                      class="row gy-2 gx-3 align-items-center"
                      @submit.stop.prevent="submitSelfieStatus"
                      v-if="isSelfieEdit"
                    >
                      <div class="col-sm-auto">
                        <label
                          class="visually-hidden"
                          for="inlineFormInputName2"
                          >Selfie Image Status</label
                        >
                        <!-- <i
                          class="far fa-eye ms-1"
                          v-b-popover.hover="'View OCR text'"
                          v-b-modal.view-doc-text
                        ></i> -->
                        <b-form-select
                          class="form-select"
                          id="gender-input"
                          type="text"
                          autocomplete="off"
                          :options="document_status"
                          v-model="guest.selfie_image_status"
                        >
                        </b-form-select>
                      </div>
                      <div class="col-sm-auto">
                        <button class="btn btn-primary">Save</button>
                      </div>
                    </b-form>
                  </div>
                  <div class="col-md-4" v-else>
                    <div class="placeholder-glow">
                      <span class="placeholder w-100 h-200"></span>
                    </div>
                    <div class="placeholder-glow mt-1">
                      <label for="" class="form-label"
                        >Selfie Image Status
                        <i
                          class="far fa-eye ms-1"
                          v-b-popover.hover="'View OCR text'"
                          v-b-modal.view-doc-text
                        ></i>
                      </label>
                      <span class="placeholder w-100"></span>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="text">Last Name </label>
                          <b-form-input
                            id="first-last-input"
                            type="text"
                            placeholder="Last Name"
                            v-model="guest.last_name"
                            autocomplete="off"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="text">First Name </label>
                          <b-form-input
                            id="first-last-input"
                            type="text"
                            placeholder="First Name"
                            v-model="guest.first_name"
                            autocomplete="off"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="tel">Mobile </label>
                          <vue-tel-input
                            class="text-dark-gray"
                            v-model="guest.mobile"
                            autoFormat
                            :autoDefaultCountry="false"
                            :defaultCountry="
                              currentProps.guest.mobile_iso !== undefined &&
                              currentProps.guest.mobile_iso !== null
                                ? currentProps.guest.mobile_iso
                                : 'US'
                            "
                            :dropdownOptions="{
                              showDialCodeInList: true,
                              showDialCodeInSelection: true,
                              showFlags: true,
                              width: '390px',
                              showSearchBox: true,
                            }"
                            @country-changed="countryChange(...arguments)"
                          ></vue-tel-input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="email"
                            >Email <span class="text-danger">*</span>
                          </label>
                          <b-form-input
                            id="first-last-input"
                            type="email"
                            placeholder="Email Address"
                            v-model="guest.email"
                            :class="{
                              'is-invalid': submitted && $v.guest.email.$error,
                            }"
                            autocomplete="off"
                          ></b-form-input>
                          <div
                            v-if="submitted && $v.guest.email.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.guest.email.required"
                              >Email is required.</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          class="form-label mb-3"
                          label="Gender"
                          label-for="gender"
                        >
                          <span slot="label"> Gender </span>
                          <b-form-select
                            class="form-select"
                            id="gender-input"
                            type="text"
                            autocomplete="off"
                            :options="gender_type"
                            v-model="guest.gender"
                          >
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label>Date of birth </label>
                          <b-form-input
                            id="date-of-birth-input"
                            type="text"
                            placeholder="date for birth"
                            v-model="guest.date_of_birth"
                            autocomplete="off"
                          ></b-form-input>
                        </div>
                      </div>
                      <div
                        class="col-md-6"
                        v-if="guest.selfie_image_status === 'R'"
                      >
                        <b-form-group
                          class="mb-3"
                          label="Name"
                          label-for="name-input"
                        >
                          <span slot="label">
                            Rejection Reason
                            <span class="text-danger">*</span>
                          </span>
                          <b-form-input
                            id="name-input"
                            placeholder="Enter you rejection reason"
                            type="text"
                            autocomplete="off"
                            v-model="guest.selfie_image_status_change_reason"
                            :class="{
                              'is-invalid':
                                submitted &&
                                $v.guest.selfie_image_status_change_reason
                                  .$error,
                            }"
                          ></b-form-input>
                          <div
                            v-if="
                              submitted &&
                              $v.guest.selfie_image_status_change_reason.$error
                            "
                            class="invalid-feedback"
                          >
                            <span
                              v-if="
                                !$v.guest.selfie_image_status_change_reason
                                  .required
                              "
                              >Reason is required.</span
                            >
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          class="form-label mb-0"
                          label="premium"
                          label-for="premium"
                        >
                          <span slot="label"> premium </span>
                          <b-form-select
                            class="form-select"
                            id="premium-input"
                            type="text"
                            autocomplete="off"
                            :options="[
                              { text: 'Yes', value: true },
                              { text: 'No', value: false },
                            ]"
                            v-model="guest.is_premium_guest"
                          >
                          </b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- End Personal information section -->

        <!-- Start Geolocation information section -->
        <b-card no-body>
          <b-card-header
            header-tag="header"
            role="tab"
            @click="geolocationInfo = !geolocationInfo"
          >
            <h6 class="my-1" slot="header">Geolocation Information</h6>
          </b-card-header>
          <b-collapse
            id="geolocationInfoValidation"
            :visible="geolocationInfo"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="Address Line First">Address Line First</label>
                      <b-form-input
                        id="Address Line First"
                        type="text"
                        placeholder="3159"
                        v-model="guest.address_line_first"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="Address Line second"
                        >Address Line Second
                      </label>
                      <b-form-input
                        id="Address Line second"
                        type="text"
                        placeholder="New York Avenue"
                        v-model="guest.address_line_second"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="City">City</label>
                      <b-form-input
                        id="City"
                        type="text"
                        placeholder="Sepulveda"
                        v-model="guest.city"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="state">State </label>
                      <b-form-input
                        id="state"
                        type="text"
                        placeholder="California"
                        v-model="guest.state"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="country">Country </label>
                      <b-form-input
                        id="country"
                        type="text"
                        placeholder="USA"
                        v-model="guest.country"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="zip code">Zip Code </label>
                      <b-form-input
                        id="zip code"
                        type="number"
                        placeholder="91343"
                        v-model="guest.zip_code"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- End Geolocation information section -->

        <!-- Start Document information section -->
        <b-card no-body>
          <b-card-header
            header-tag="header"
            role="tab"
            v-b-toggle.documentInfoValidation
          >
            <h6 class="my-1" slot="header">Document Information</h6>
          </b-card-header>
          <b-collapse
            id="documentInfoValidation"
            :visible="documentInfo"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <div class="col-md-4" v-if="!docImageVerification">
                    <VueDropify
                      v-if="doc_image_imgURL == ''"
                      @upload="changeDocImage($event)"
                      :src="guest.doc_image ? guest.doc_image : null"
                      message="Drop image here or click to select"
                    />
                    <vue-cropper
                      v-else
                      ref="cropper"
                      :src="doc_image_imgURL"
                      alt="Source Image"
                      class="position-relative w-100 object-fit"
                      :minCropBoxWidth="250"
                      :minCropBoxHeight="150"
                    >
                    </vue-cropper>
                    <label for="" class="mt-4 form-label"
                      >Document Image Status
                      <i
                        class="far fa-eye ms-1"
                        v-b-popover.hover="'View OCR text'"
                        v-b-modal.view-doc-text
                      ></i>
                    </label>
                    <div
                      class="badge bg-primary d-flex align-items-center justify-content-between mb-2"
                      v-if="guest.doc_image_status == 'P'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-clock"></i> Pending
                      </span>
                      <span class="fs-6"
                        ><i class="fas fa-pencil-alt" @click="editDocStatus"></i
                      ></span>
                    </div>
                    <div
                      class="badge bg-warning d-flex align-items-center justify-content-between mb-2"
                      v-if="guest.doc_image_status == 'U'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-upload"></i> Uploaded
                      </span>
                      <span class="fs-6"
                        ><i class="fas fa-pencil-alt" @click="editDocStatus"></i
                      ></span>
                    </div>
                    <div
                      class="badge bg-danger d-flex align-items-center justify-content-between mb-2"
                      v-if="guest.doc_image_status == 'R'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-ban"></i> Rejected
                      </span>
                      <span class="fs-6"
                        ><i class="fas fa-pencil-alt" @click="editDocStatus"></i
                      ></span>
                    </div>
                    <div
                      class="badge bg-success d-flex align-items-center justify-content-between mb-2"
                      v-if="guest.doc_image_status == 'V'"
                    >
                      <span class="fs-6">
                        <i class="fas fa-shield-alt"></i> Verified
                      </span>
                      <span class="fs-6"
                        ><i class="fas fa-pencil-alt" @click="editDocStatus"></i
                      ></span>
                    </div>
                    <b-form
                      inline
                      class="row gy-2 gx-3 align-items-center"
                      @submit.stop.prevent="submitDocStatus"
                      v-if="isDocEdit"
                    >
                      <div class="col-sm-auto">
                        <label
                          class="visually-hidden"
                          for="inlineFormInputName2"
                          >Document Status</label
                        >
                        <b-form-select
                          class="form-select"
                          id="gender-input"
                          type="text"
                          autocomplete="off"
                          :options="document_status"
                          v-model="guest.doc_image_status"
                        >
                        </b-form-select>
                      </div>
                      <div class="col-sm-auto">
                        <button class="btn btn-primary">Save</button>
                      </div>
                    </b-form>
                  </div>
                  <div class="col-md-4" v-else>
                    <div class="placeholder-glow">
                      <span class="placeholder w-100 h-200"></span>
                    </div>
                    <div class="placeholder-glow mt-1">
                      <label for="" class="form-label"
                        >Document Image Status
                      </label>
                      <span class="placeholder w-100"></span>
                    </div>
                  </div>

                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-md-6">
                        <b-form-group
                          class="form-label mb-3"
                          label="Document type"
                          label-for="documentType"
                        >
                          <b-form-select
                            class="form-select"
                            id="gender-input"
                            type="text"
                            autocomplete="off"
                            :options="document_type"
                            v-model="guest.doc_type"
                          >
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          class="form-label mb-3"
                          label="Document Number"
                          label-for="DocumentNumber"
                        >
                          <b-form-input
                            id="Document Number"
                            type="text"
                            placeholder="Document Number"
                            v-model="guest.doc_number"
                            autocomplete="off"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label>Issue date</label>
                          <b-form-input
                            id="doc-issue-input"
                            type="text"
                            placeholder="doc issue date"
                            v-model="guest.doc_issue_date"
                            autocomplete="off"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label>Expire date</label>
                          <b-form-input
                            id="doc-expire-input"
                            type="text"
                            placeholder="doc expire date"
                            v-model="guest.doc_expire_date"
                            autocomplete="off"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="Issued By">Issued By </label>
                          <b-form-input
                            id="Issued By"
                            type="text"
                            autocomplete="off"
                            placeholder="Issue By"
                            v-model="guest.doc_issued_by"
                          ></b-form-input>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="guest.doc_image_status === 'R'">
                      <b-form-group
                        class="mb-3"
                        label="Name"
                        label-for="name-input"
                      >
                        <span slot="label">
                          Rejection Reason
                          <span class="text-danger">*</span>
                        </span>
                        <b-form-input
                          id="name-input"
                          placeholder="Enter you rejection reason"
                          type="text"
                          autocomplete="off"
                          v-model="guest.doc_image_status_change_reason"
                          :class="{
                            'is-invalid':
                              submitted &&
                              $v.guest.doc_image_status_change_reason.$error,
                          }"
                        ></b-form-input>
                        <div
                          v-if="
                            submitted &&
                            $v.guest.doc_image_status_change_reason.$error
                          "
                          class="invalid-feedback"
                        >
                          <span
                            v-if="
                              !$v.guest.doc_image_status_change_reason.required
                            "
                            >Reason is required.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- End Document information section -->

        <div class="col-md-12">
          <b-button
            class="float-end"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
            >Cancel</b-button
          >
          <b-button
            v-if="this.currentProps.isEdit === false"
            class="float-end mx-2"
            variant="outline-primary"
            type="submit"
            @click="saveAndAddNew"
            :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew === true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i
            >Save & Add</b-button
          >
          <b-button
            class="float-end mx-2"
            variant="outline-primary"
            type="submit"
            :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew !== true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ this.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </form>
    </div>
    <!-- Modal is use for display settle amount -->
    <b-modal
      id="view-doc-text"
      centered
      size="lg"
      title="Document OCR Text Infomation"
      hide-footer
    >
      <div class="row" v-if="guest">
        <div class="d-flex align-items-center mb-3">
          <h5 class="text-capitalize mb-0">
            Selfie Image Match With Doc Score
          </h5>
          <span class="d-block mx-3">-</span>
          <p class="font-size-16 mb-0">
            {{ guest.selfie_image_match_with_doc_score }}
          </p>
        </div>
        <hr />
        <div
          class="col-md-4"
          v-for="(item, key, index) in guest.doc_ocr_text"
          :key="index"
        >
          <h5 class="font-size-14 text-capitalize">
            {{ key.replaceAll("_", " ") }}
          </h5>
          <p class="mb-0">
            {{ item ? item : "-" }}
          </p>
          <hr />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.badge {
  padding: 10px;
}
</style>
